// Case studies — anonymized placeholders until client-approved content is supplied.
// Content rule: never publish client names, metrics, quotes or logos without written approval.
//
// TO PUBLISH A REAL STUDY: copy an entry below, set `placeholder: false`, then fill in:
//   client:  "Acme Health"                              (approved client name, or an industry description)
//   metrics: [{ value: "42%", label: "faster intake" }, { value: "$1.2M", label: "annual savings" }]  (2–3 approved numbers)
//   quote:   { text: "…", name: "Jane Doe", role: "CIO, Acme Health" }   (optional, approved)
//   outcome: one-sentence summary of the result
// Metric tiles and the quote render automatically when present; the "Placeholder" badge disappears when placeholder is false.
export const CASE_CATEGORIES = ["All", "AI", "Cloud", "Software", "Data", "Automation", "Staffing"];

export const CASE_STUDIES = [
  {
    id: "cs-ai-1", category: "AI", client: "Regional Healthcare Provider", placeholder: true,
    title: "AI-assisted intake triage",
    challenge: "Manual review of inbound patient requests created queues and inconsistent prioritization.",
    context: "Multi-site healthcare provider with legacy scheduling systems.",
    approach: "Human-in-the-loop AI strategy with clear escalation paths.",
    solution: "NLP classification and priority scoring integrated into the existing scheduling workflow.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["NLP", "Python", "Cloud APIs"],
  },
  {
    id: "cs-cloud-1", category: "Cloud", client: "Mid-market Manufacturer", placeholder: true,
    title: "Cloud migration and modernization",
    challenge: "Aging on-premise infrastructure limited scalability and increased operating risk.",
    context: "Manufacturing operations across multiple plants.",
    approach: "Phased migration with parallel-run validation.",
    solution: "Cloud architecture, containerization and monitoring with DevOps automation.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["Kubernetes", "Terraform", "Observability"],
  },
  {
    id: "cs-sw-1", category: "Software", client: "Professional Services Firm", placeholder: true,
    title: "Client portal modernization",
    challenge: "A legacy client portal was costly to maintain and difficult to extend.",
    context: "Advisory firm serving enterprise clients.",
    approach: "Incremental modernization with feature parity milestones.",
    solution: "Modern web application, API layer and integration with existing systems.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["React", "APIs", "Cloud"],
  },
  {
    id: "cs-data-1", category: "Data", client: "Financial Services Company", placeholder: true,
    title: "Unified data platform",
    challenge: "Reporting relied on fragmented spreadsheets and inconsistent definitions.",
    context: "Regulated finance environment with audit requirements.",
    approach: "Governance-first data architecture.",
    solution: "Data warehouse, ELT pipelines and governed BI layer.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["Data Warehouse", "ELT", "BI"],
  },
  {
    id: "cs-auto-1", category: "Automation", client: "Logistics Operator", placeholder: true,
    title: "Document automation",
    challenge: "High volumes of shipping documents were processed manually.",
    context: "Distribution operations with strict turnaround expectations.",
    approach: "Automate the repetitive, keep humans on exceptions.",
    solution: "Document AI extraction with RPA-driven downstream processing.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["Document AI", "RPA", "Workflow"],
  },
  {
    id: "cs-staff-1", category: "Staffing", client: "Technology Company", placeholder: true,
    title: "Project team staffing",
    challenge: "A time-boxed platform initiative required specialized engineers quickly.",
    context: "Remote/hybrid engineering organization.",
    approach: "Skills-matched contract staffing with recruiter oversight.",
    solution: "Contract and contract-to-hire placements aligned to the project roadmap.",
    outcome: "Outcome metrics pending client approval.",
    tech: ["Technical Screening", "ATS", "Onboarding"],
  },
];
